import { render } from "./Kozhencherry.vue?vue&type=template&id=43fa1dbc"
import script from "./Kozhencherry.vue?vue&type=script&lang=ts"
export * from "./Kozhencherry.vue?vue&type=script&lang=ts"
script.render = render

export default script